// Thin GraphQL client — `fetch` + Authorization header. We avoided adding
// @apollo/client or urql because the Sales Cabinet only has ~7 queries/
// mutations; 400kb of client library for that is wasteful.
//
// Error handling: any `errors` array in the GraphQL response is merged into
// a single Error whose message is the concatenation of individual messages.
// A 401 from the middleware (unauthenticated / IsAdmin=false) propagates
// as an HTTP error — the UI layer catches it and redirects to /login.

import { getToken, logout } from "./auth";

export async function gql<T = unknown>(
  query: string,
  variables?: Record<string, unknown>,
): Promise<T> {
  const token = getToken();
  const resp = await fetch("/graphql", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ query, variables }),
  });

  if (resp.status === 401 || resp.status === 403) {
    logout();
    throw new Error("Сессия истекла");
  }

  const json = (await resp.json()) as {
    data?: T;
    errors?: Array<{ message: string; extensions?: { code?: string } }>;
  };

  if (json.errors && json.errors.length > 0) {
    // Admin directive failures come through here as "admin access required".
    const adminErr = json.errors.find((e) => e.message === "admin access required");
    if (adminErr) {
      logout();
      throw new Error("Доступ только для admin");
    }
    throw new Error(json.errors.map((e) => e.message).join("; "));
  }

  if (!json.data) {
    throw new Error("Empty response from server");
  }
  return json.data;
}
